"use client";

import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import type { FAQVariant01Props } from "../../props";

export const FAQVariant01 = ({ faq }: FAQVariant01Props) => {
  const [open, setOpen] = useState<number>(-1);
  const refs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    refs.current = refs.current.slice(0, faq.length);
  }, [faq.length]);

  const toggle = (idx: number) =>
    setOpen((current) => (current === idx ? -1 : idx));

  return (
    <section className="py-[40px]">
      <div className="w-[90%] mx-auto max-w-[1500px] px-[10px]">
        <h2 className="text-[36px] font-semibold mb-6">Dúvidas frequentes</h2>

        <ul>
          {faq.map(({ question, answer }, idx) => {
            const isOpen = idx === open;

            const setPanelRef = (el: HTMLDivElement | null) => {
              refs.current[idx] = el;
            };

            const maxHeight = isOpen ? refs.current[idx]?.scrollHeight ?? 0 : 0;

            return (
              <li key={idx} className="border-b-[1px]">
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  aria-controls={`panel-${idx}`}
                  className="w-full flex items-center justify-between py-4 text-left font-medium  hover:underline transition-opacity"
                >
                  <span>{question}</span>
                  <ChevronDown
                    size={24}
                    className={`transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <div
                  id={`panel-${idx}`}
                  ref={setPanelRef}
                  style={{ maxHeight }}
                  className="overflow-hidden transition-[max-height] duration-300 ease-in-out"
                >
                  <div className="px-4 pt-2 pb-4">
                    <p className="text-[.8rem]">{answer}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
